import { escapeHtml } from './html.js';

// Avatar emoji/texte court borné : on autorise un petit emoji (éventuellement
// composé via ZWJ) ou un texte très court, sans HTML ni caractères de contrôle.
export const MAX_AVATAR_GRAPHEMES = 4;

function splitGraphemes(str) {
  if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') {
    const seg = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
    return [...seg.segment(str)].map((s) => s.segment);
  }
  return [...str];
}

export function sanitizeAvatarEmoji(raw) {
  if (raw == null) return '';
  const value = String(raw)
    .replace(/\p{Cc}/gu, '') // caractères de contrôle
    .replace(/[<>]/g, '')    // pas d'injection HTML
    .trim();
  if (!value) return '';
  return splitGraphemes(value).slice(0, MAX_AVATAR_GRAPHEMES).join('');
}

export function avatarInitial(pseudo) {
  const value = String(pseudo ?? '').trim();
  return value ? value.charAt(0).toUpperCase() : '?';
}

// Ne garde que des URLs d'images sûres (http/https ou data:image). Bloque les
// schémas dangereux (javascript:, data:text/html, etc.).
export function sanitizeAvatarUrl(raw) {
  if (raw == null) return '';
  const value = String(raw).trim();
  if (!value || value.includes('pinokio-temp')) return '';
  if (/^https?:\/\//i.test(value)) return value;
  if (/^data:image\//i.test(value)) return value;
  return '';
}

function avatarFallbackText(profile) {
  return sanitizeAvatarEmoji(profile?.avatar_emoji) || avatarInitial(profile?.pseudo);
}

function avatarFallbackOnErrorAttribute() {
  // Repli sans dépendre du réseau ni du CSP : si l'image est bloquée, privée,
  // supprimée ou sans CORS exploitable, on remplace par l'emoji/l'initiale.
  return "this.replaceWith(document.createTextNode(this.dataset.avatarFallback || '?'))";
}

// Rendu du contenu interne d'une pastille avatar : image > emoji > initiale.
// Une photo importée prime sur l'emoji ; l'emoji reste un repli si aucune photo.
export function renderAvatarInner(profile, { imgStyle = 'width:100%;height:100%;border-radius:50%;object-fit:cover;' } = {}) {
  const url = sanitizeAvatarUrl(profile?.avatar_url);
  const fallback = avatarFallbackText(profile);
  if (url) {
    return `<img src="${escapeHtml(url)}" alt="" referrerpolicy="no-referrer" data-avatar-fallback="${escapeHtml(fallback)}" onerror="${avatarFallbackOnErrorAttribute()}"${imgStyle ? ` style="${imgStyle}"` : ''} />`;
  }
  const emoji = sanitizeAvatarEmoji(profile?.avatar_emoji);
  if (emoji) return `<span class="avatar-emoji">${escapeHtml(emoji)}</span>`;
  return escapeHtml(avatarInitial(profile?.pseudo));
}
